// extracted by mini-css-extract-plugin
export default {"container":"MiniCards_container__Y28Nw","cardsWrapper":"MiniCards_cardsWrapper__MQ6a-","title":"MiniCards_title__Bci7X","break":"MiniCards_break__ItL2Y"};